import { createContext, useContext } from "react";
import type { ProjectState, ProjectSummary, ProjectSnapshot, UserPreferences } from "../types";

// ── StorageProvider Interface ──
// Abstracts all data persistence so we can swap localStorage ↔ Supabase

export interface StorageProvider {
  // Project CRUD
  loadCurrentProject(): ProjectState | null;
  saveCurrentProject(state: ProjectState): void;
  listProjects(): Record<string, ProjectState & { savedAt: string }>;
  saveProject(name: string, state: ProjectState): void;
  deleteProject(name: string): void;

  // Preferences
  loadPreferences(): UserPreferences;
  saveShortcuts(shortcuts: UserPreferences["shortcuts"]): void;
  saveTypologyPrefs(prefs: UserPreferences["typologyPrefs"]): void;

  // History notes
  loadHistoryNotes(): Record<string, string>;
  saveHistoryNotes(notes: Record<string, string>): void;

  // Auth (no-op for localStorage, real for Supabase)
  getCurrentUser(): { id: string; email: string } | null;
  isAuthenticated(): boolean;
}

// ── React Context ──
export const StorageContext = createContext<StorageProvider | null>(null);

export function useStorage(): StorageProvider {
  const ctx = useContext(StorageContext);
  if (!ctx) throw new Error("useStorage must be used within StorageContext.Provider");
  return ctx;
}
